const validateDownloadFormat = (params) => {
  if (params?.format && !["excel", "pdf"].includes(params.format)) {
    throw new Error("Invalid format. strictly allowed 'excel' or 'pdf'");
  }
};

export const createPurchaseApi = (api) => ({
  // Purchase Order
  getPurchaseOrders: (fpoId) => api.get(`/fpo/${fpoId}/purchase/order`),
  getPurchaseOrderByVendor: (fpoId, vendorId) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/purchase/order`),
  getPurchaseOrderById: (fpoId, vendorId, id) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/purchase/order/${id}`),
  createPurchaseOrder: (fpoId, vendorId, data) => api.post(`/fpo/${fpoId}/vendor/${vendorId}/purchase/order`, data),
  updatePurchaseOrder: (fpoId, vendorId, id, data) => api.patch(`/fpo/${fpoId}/vendor/${vendorId}/purchase/order/${id}`, data),
  deletePurchaseOrder: (fpoId, vendorId, id) => api.delete(`/fpo/${fpoId}/vendor/${vendorId}/purchase/order/${id}`),
  downloadPurchaseOrderReport: (fpoId, params) => {
    validateDownloadFormat(params);
    return api.get(`/fpo/${fpoId}/purchase/order/download`, { params, responseType: "blob" });
  },

  // Purchase Invoice
  getPurchaseInvoices: (fpoId) => api.get(`/fpo/${fpoId}/purchase/invoice`),
  getPurchaseInvoiceByVendor: (fpoId, vendorId) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/purchase/invoice`),
  getPurchaseInvoiceById: (fpoId, vendorId, id) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/purchase/invoice/${id}`),
  createPurchaseInvoice: (fpoId, vendorId, data) => api.post(`/fpo/${fpoId}/vendor/${vendorId}/purchase/invoice`, data),
  updatePurchaseInvoice: (fpoId, vendorId, id, data) => api.patch(`/fpo/${fpoId}/vendor/${vendorId}/purchase/invoice/${id}`, data),
  deletePurchaseInvoice: (fpoId, vendorId, id) => api.delete(`/fpo/${fpoId}/vendor/${vendorId}/purchase/invoice/${id}`),
  downloadPurchaseInvoiceReport: (fpoId, params) => {
    validateDownloadFormat(params);
    return api.get(`/fpo/${fpoId}/purchase/invoice/download`, { params, responseType: "blob" });
  },

  // Purchase Return
  getPurchaseReturns: (fpoId) => api.get(`/fpo/${fpoId}/purchase/return`),
  getPurchaseReturnByPurchase: (fpoId, vendorId, purchaseId) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/purchase/${purchaseId}`),
  getPurchaseReturnById: (fpoId, vendorId, purchaseId, id) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/purchase/${purchaseId}/return/${id}`),
  createPurchaseReturn: (fpoId, vendorId, purchaseId, data) => api.post(`/fpo/${fpoId}/vendor/${vendorId}/purchase/${purchaseId}`, data),
  updatePurchaseReturn: (fpoId, vendorId, purchaseId, id, data) => api.patch(`/fpo/${fpoId}/vendor/${vendorId}/purchase/${purchaseId}/return/${id}`, data),
  deletePurchaseReturn: (fpoId, vendorId, purchaseId, id) => api.delete(`/fpo/${fpoId}/vendor/${vendorId}/purchase/${purchaseId}/return/${id}`),
  downloadPurchaseReturnReport: (fpoId, params) => {
    validateDownloadFormat(params);
    return api.get(`/fpo/${fpoId}/return/download`, { params, responseType: "blob" });
  },

  // Purchase Stock Reports
  getPurchaseStock: (fpoId, startDate, endDate) => api.get(`/fpo/${fpoId}/purchase/stock`, { params: { startDate, endDate } }),
  getPurchaseReturnStock: (fpoId, startDate, endDate) => api.get(`/fpo/${fpoId}/purchase/return/stock`, { params: { startDate, endDate } }),
  getPurchaseOverallStock: (fpoId, startDate, endDate) => api.get(`/fpo/${fpoId}/purchase/overall/stock`, { params: { startDate, endDate } }),
  downloadPurchaseOverallStockReport: (fpoId, startDate, endDate, format = "excel") =>
    api.get(`/fpo/${fpoId}/purchase/registry/download`, { params: { startDate, endDate, format }, responseType: "blob" }),
});
